export const QueryKeys = {
    GetDocuments: 'get-documents',
}
